// The production build (`bun build --env='PUBLIC_*'`) puts each
// `process.env.PUBLIC_*` value into the code as a literal. The browser has no
// `process` global, so do not test for one: a `typeof process` guard makes the
// literal unreachable and every build reports "unknown". The HTML dev server
// leaves `process.env` in the code; the read then throws and gives "unknown".
function publicEnv(read: () => string | undefined): string {
  try {
    return read() || "unknown";
  } catch {
    return "unknown";
  }
}

export const BUILD_SHA = publicEnv(() => process.env.PUBLIC_BUILD_SHA);
export const BUILD_VERSION = publicEnv(() => process.env.PUBLIC_BUILD_VERSION);
